/**      .----.
 *       _.'__    `.
 *   .--($)($$)---/#\
 * .' @          /###\
 * :         ,   #####
 *  `-..__.-' _.-\###/
 *        `;_:    `"'
 *      .'"""""`.
 *     /,     ,\\
 *    //  !BUG  \\
 *    `-._______.-'
 *    ___`. | .'___
 *   (______|______)
 *
 *  易税云导入组件
 *  @author:    <sujingjun@467794164@qq.com>
 *  @date:      2017年11月18日
 *  email: 467794164@qq.com
 *  @version:   1.0
 *  @params: config:{
 *   code: "string", //导入类型
     validate: {

     }, //文件类型
 *   callback: function //关闭弹窗后回掉
 *  }
 * tangyuning 2018-08-23修改
 * config增加可选参数:
 * downloadAppName:下载模版接口的appname
 * data:导入接口增加的参数
 * url:导入接口的地址
 * uploadId:传入的导入的元素ID
 * uploadCallback：点击导入时执行的事件，事件结束后需执行传入uploadId元素的点击事件
 */
import template from './importexcel.html'

importexcel.$inject = ['$rootScope', 'importevent', 'importexcelApi', 'Upload', 'logger', '$timeout', 'httpRequest', '$uibModal']
export default function importexcel($rootScope, importevent, importexcelApi, Upload, logger, $timeout, httpRequest, $uibModal) {
    return {
        restrict: 'EA',
        scope: {
            config: '=',
        },
        template,
        link(scope, element, attrs) {
            // 点击导入选择文件
            // 参数
            const _config = scope.config
            let downloadUrl = scope.config.downloadUrl || ''
            scope.$watch(
                'config',
                function (n, o) {
                    downloadUrl = scope.config.downloadUrl
                },
                true
            )
            _config.providerFlag = _config.providerFlag || IS_PROVIDER
            let uploadId = 'uploadId'
            for (let i = 0; i < 10; i++) {
                uploadId += parseInt(Math.random() * 10)
            }
            scope.uploadId = scope.config.uploadId || uploadId
            scope.hasUpload = !!_config.uploadCallback
            scope.isCollapsed = false
            scope.upload = function upload() {
                _config.uploadCallback && _config.uploadCallback()
            }
            scope.readDiskFn = function () {
                scope.config.readDiskCb && scope.config.readDiskCb(_config, scope.handleImportRes)
            }
            // 模板下载
            scope.downloadExel = function () {
                const appName = _config.downloadAppName || host.etcloud
                if (['CUSTOMER_INFO', 'GOODS_INFO', 'SMART_GOODS_INFO', 'VEHICLE_GOOD', 'GOODS_MAPPING', 'OVAT_TAX4_DRAWER', 'OVAT_TAX4_DRAWER_JOIN', 'OVAT_TAX_ACCOUNT_IMPORT'].indexOf(_config.code) > -1) {
                    window.open(`${appName}dlTaskService/export_${_config.code}?accessToken=${$rootScope.idToken}`)
                    return
                }
                if (['GSCONFIG_NOTIMPORT'].indexOf(_config.downloadCode) > -1) {
                    // 个税模板下载
                    window.open(`${appName}${_config.downloadUrl}?code=${_config.downloadCode}&accessToken=${$rootScope.idToken}`)
                    return
                }
                if (['OVAT_TAX4_DRAWER_UPDATE'].indexOf(_config.code) > -1) {
                    // 税务账号更新模板下载
                    scope.config.taxOfficeAccountDownload()
                    return
                }
                if (['REGISTER_UPDATE_IMPORT'].indexOf(_config.code) > -1) {
                    // 注册码管理更新模板下载
                    scope.config.downloadRegisterUpdateTemplate()
                    return
                }
                if (['IVAT_TAX4_BILL_UPDATE'].indexOf(_config.code) > -1) {
                    // 发票种类修正更新模板下载
                    scope.config.exportNegativeInvoice()
                    return
                }
                if (downloadUrl) {
                    window.open(`${appName}${downloadUrl}`)
                    return
                }
                window.open(`${appName}${_config.providerFlag ? 'supplier/dl/supDlTaskService' : 'dl/dlTaskService'}/export_${_config.code}?accessToken=${$rootScope.idToken}`)
            }
            // 个税导入模板判断
            scope.handleTaxImport = function (response) {
                if (_config.handleTaxImport && response.data.msgCode == 10001) {
                    _config.handleTaxImport(response)
                    return false
                }
                return true
            }
            scope.uploadFiles = function (file, errFiles, word) {
                // 不符合文件格式的错误提示
                if (file == null && errFiles.length >= 1) {
                    logger.logError(`文件类型错误，文件大小不超过${_config.validate._validate.size.max}，支持${word || _config.validate.pattern}格式`)
                    return
                }
                if (file) {
                    const appName = _config.appName || host.etcloud
                    const data = {
                        importFile: file,
                        code: _config.code,
                        ..._config.data,
                    }
                    const url = _config.url || `${_config.providerFlag ? 'supplier/dl/supDlTaskService' : 'dl/dlTaskService'}/import_${_config.code}`
                    console.log(data, url)
                    file.upload = Upload.upload({
                        url: appName + url,
                        data,
                    })
                    // 文件上传
                    // loading动画
                    const importinglayer = layer.msg(scope.config.msg || '玩命上传中，请耐心等待', {
                        time: 0,
                        skin: 'layer-loading-self',
                        icon: 16,
                        shade: 0.5,
                    })
                    file.upload.then(
                        (response) => {
                            $timeout(() => {
                                scope.handleTaxImport(response)
                                scope.handleImportRes(response, importinglayer, _config)
                            })
                        },
                        (response) => {
                            if (response.status > 0) {
                                // 关闭loading
                                layer.close(importinglayer)
                                logger.logError('上传失败 ')
                            }
                        },
                        (evt) => {
                            file.progress = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total))
                            console.log(file.progress)
                        }
                    )
                }
            }
            scope.uploadFilesAuth = function (file, errFiles, word) {
                // 不符合文件格式的错误提示
                if (file == null && errFiles.length >= 1) {
                    logger.logError(`文件类型错误，文件大小不超过${_config.validate._validate.size.max}，支持${word || _config.validate.pattern}格式`)
                    return
                }
                if (file) {
                    const appName = _config.appName || host.etcloud
                    const data = {
                        importFile: file,
                        code: 'AUTHORIZATION_USER_INFO',
                        ..._config.data,
                    }
                    const url = _config.url || `${_config.providerFlag ? 'supplier/dl/supDlTaskService' : 'dl/dlTaskService'}/import_AUTHORIZATION_USER_INFO`
                    console.log(data, url)
                    file.upload = Upload.upload({
                        url: appName + url,
                        data,
                    })
                    // 文件上传
                    // loading动画
                    const importinglayer = layer.msg(scope.config.msg || '玩命上传中，请耐心等待', {
                        time: 0,
                        skin: 'layer-loading-self',
                        icon: 16,
                        shade: 0.5,
                    })
                    file.upload.then(
                        (response) => {
                            $timeout(() => {
                                scope.handleTaxImport(response)
                                scope.handleImportRes(response, importinglayer, _config)
                            })
                        },
                        (response) => {
                            if (response.status > 0) {
                                // 关闭loading
                                layer.close(importinglayer)
                                logger.logError('上传失败 ')
                            }
                        },
                        (evt) => {
                            file.progress = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total))
                            console.log(file.progress)
                        }
                    )
                }
            }

            scope.uploadTxT = function () {
                let tips = '商品编码'
                switch (_config.code) {
                    case 'GOODS_INFO':
                        tips = '商品编码'
                        break
                    case 'VEHICLE_GOOD':
                        tips = '车辆编码'
                        break
                    default:
                        break
                }
                const opt = {
                    btn: ['确定', '取消'],
                    title: '操作提醒',
                    message: `请确保使用从开票软件“${tips}”列表中导出的TXT文件！`,
                    icon: 'tishi',
                }
                let titleHtml = ''
                let iconHtml = ''
                let contentHtml = ''
                // 是否有标题
                if (opt.title && typeof opt.title === 'string') {
                    titleHtml = `<div class="message-title">${opt.title}</div>`
                }
                // 是否有icon
                if (opt.icon && typeof opt.icon === 'string') {
                    iconHtml = `<div class="content-left"><i class="icon iconfont icon-${opt.icon} iconfont-${opt.icon}"></i></div>`
                }
                contentHtml = `<div class="layer-msg-content">
                        ${iconHtml}
                        <div class="content-center">
                            ${titleHtml}
                            <div class="message-content">${opt.message}</div>
                        </div>
                    </div>`
                layer.open({
                    type: 0,
                    title: false,
                    resize: false,
                    closeBtn: 0,
                    btn: opt.btn,
                    shadeClose: false,
                    skin: 'layer-message-self',
                    content: `${contentHtml}`,
                    yes(index, layero) {
                        // 按钮【按钮一】的回调
                        layer.close(index)
                        angular.element('#upload-txt').click()
                    },
                    btn2(index, layero) {
                        // 按钮【按钮二】的回调
                        // return false 开启该代码可禁止点击该按钮关闭
                        // layer.close(index)
                        // defered.reject()
                    },
                })
            }
            // 导入结果（覆盖弹框、结果详情弹框）
            scope.handleImportRes = function (response, importinglayer, _config, tips) {
                if (!response.data.success) {
                    // 关闭loading
                    if (importinglayer) layer.close(importinglayer)
                    return logger.logError(response.data.message || tips || '上传失败')
                }
                if (response.data.value.confirmCount && response.data.value.confirmCount > 0) {
                    layer.close(importinglayer)
                    // 用户选择跳过/覆盖弹窗
                    const modalData = {
                        detail: response.data.value,
                    }
                    const modalInstance = $uibModal.open({
                        templateUrl: 'importModalConfirm.html',
                        controller: 'modalConfirmCtrl',
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-md',
                        bindToController: true,
                        resolve: {
                            items1() {
                                return modalData
                            },
                        },
                    })
                    // 弹窗回调
                    modalInstance.result.then(
                        (confirmRes) => {
                            _config.callback && _config.callback()
                        },
                        () => {
                            _config.callback && _config.callback()
                        }
                    )
                } else {
                    // 初始化 详情弹窗参数 结果查询参数
                    const { batchNo } = response.data.value
                    const { sourceCount } = response.data.value
                    const { errorCount } = response.data.value
                    const { dlType } = response.data.value
                    const _req = {
                        pageNum: 1,
                        pageSize: 10,
                        param: batchNo,
                    }
                    // 请求错误信息
                    httpRequest.post_getPageDlBatchInfoList(_req).then((res) => {
                        // 关闭loading
                        layer.close(importinglayer)
                        // 获取导出信息详细数据
                        const goodsImportRes = res.data.value
                        const modalData = {
                            // 返回给弹窗的数据
                            idToken: $rootScope.idToken,
                            params: {
                                batchNo,
                                sourceCount,
                                successCount: sourceCount - errorCount,
                                errorCount,
                                data: goodsImportRes,
                                dlType,
                            },
                        }
                        // 弹窗实例
                        const modalInstance = $uibModal.open({
                            templateUrl: 'importModalContent.html',
                            controller: 'modalImportCtrl',
                            backdrop: 'static',
                            windowClass: 'mod-modal-importexcel mod-modal mod-modal-lg',
                            bindToController: true,
                            resolve: {
                                items1() {
                                    return modalData
                                },
                            },
                        })
                        // 弹窗回掉
                        modalInstance.result.then(
                            (selectedItem) => {
                                _config.callback && _config.callback()
                            },
                            () => {
                                console.log(`Modal dismissed at: ${new Date()}`)
                                _config.callback && _config.callback()
                            }
                        )
                    })
                }
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/importexcel/importexcel.js